import React, { useEffect, useState } from "react";
import AppButton from "../../common/AppButton";
import config from "../../config/config";
import colors from "../../config/colors";
import AppInput from "../../common/AppInput";
import { cloneDeep } from "lodash";
import api from "../../config/api";
import Table from "../../common/Table";
import moment from "moment";
import { MdMenu } from "react-icons/md";
import { toast } from "react-toastify";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { getExpenseCategories } from "../../stores/ExpenseCategoryStore";
const size = config.iconSize;

const formInit = {
  category: "",
  date: new Date().toISOString(),
};

const header = [
  { title: "Date", name: "date" },
  { title: "Category", name: "category" },
];
export default function ExpenseSettingsModel() {
  const Body = ({ onDone }) => {
    const [form, setForm] = useState(cloneDeep(formInit));
    const queryClient = useQueryClient();

    const { data: list } = useQuery({
      queryFn: () => getExpenseCategories(),
      queryKey: ["expenseCategory"],
    });

    const handleChange = ({ target }) => {
      const name = target.name;
      const value = target.value;
      setForm({ ...form, [name]: value });
    };

    const handleSubmit = async (event) => {
      event.preventDefault();

      const res = await api.post("expenseCategory", form);
      if (!res.ok) return toast.error(res.originalError.message);
      setForm(formInit);
      queryClient.invalidateQueries(["expenseCategory"]);

      toast.success("Category has been successfully added.");

      onDone && onDone();
    };

    return (
      <div>
        <form onSubmit={handleSubmit}>
          <div
            className="d-flex"
            style={{ gap: 30, alignItems: "flex-end", padding: "0px 30px" }}
          >
            <AppInput
              name="category"
              onChange={handleChange}
              label="Category"
              required
              floatLabel
              value={form.category}
            />
            <AppButton
              type="submit"
              text="Create"
              style={{ marginBottom: 13 }}
              className="btn-primary"
            />
          </div>
        </form>

        <br />
        <br />
        <div style={{ padding: "0px 30px" }}>
          {list?.length > 0 && (
            <Table
              normalTable
              tableClass="pop-table"
              header={header}
              data={list.map((i) => {
                return { ...i, date: moment(i.date).format("DD/MM/YYYY") };
              })}
            />
          )}
        </div>
      </div>
    );
  };
  const Footer = () => {
    return (
      <AppButton
        text="Save"
        form="form"
        type="submit"
        className="text-primary btn-light"
      />
    );
  };
  const Header = () => {
    return (
      <span className="d-flex" style={{ alignItems: "center" }}>
        <MdMenu size={size} color={colors.silver} style={{ marginRight: 5 }} />
        <b>Expense setting</b>
      </span>
    );
  };

  return { Header, Body, Footer };
}
